import { UsersService } from 'data/services';
import { UsersServiceInterface } from 'domain/services';
import { makeGetListProfile } from 'main/factories/usecases/users/remote-get-list-profile-factory';
import { makeRemoteUpdateStatusAssociatePersonProfile } from 'main/factories/usecases/users/update-status-associate-profile/update-status-associate-profile';
import { makeRemoteGetUsersOnline } from 'main/factories/usecases/users/users-online/get-users-online';
import { makeRemoteGetUsersOnlineMaps } from 'main/factories/usecases/users/users-online/get-users-online-maps';

export const makeUsersService = (): UsersServiceInterface => {
  return new UsersService(
    makeGetListProfile(),
    makeRemoteGetUsersOnline(),
    makeRemoteGetUsersOnlineMaps(),
    makeRemoteUpdateStatusAssociatePersonProfile(),
  );
};
